import { z } from 'zod';

import { fetchMessages, MESSAGE_MODELS, messageMetadataSchema } from './messages-api';

export type RoundingRule = 'old' | 'new';

const LABORATORY_MODULE = 'LABORATORIO';
const NON_NORMAL_TIE_PREFERENCE = 'ST_GERMINACAO_EMPATE_NAO_NORMAIS';

const ROUNDING_RULES: Record<string, RoundingRule> = {
  S: 'new',
  N: 'old',
};

export const DEFAULT_ROUNDING_RULE: RoundingRule = 'new';

const systemPreferenceSchema = messageMetadataSchema.extend({
  modulo: z.string().nullish(),
  campo: z.string().nullish(),
  valor: z.string().nullish(),
});

type SystemPreference = z.output<typeof systemPreferenceSchema>;

export type LabSettings = {
  roundingRule: RoundingRule;
};

function isNonNormalTiePreference(preference: SystemPreference): boolean {
  return preference.modulo === LABORATORY_MODULE && preference.campo === NON_NORMAL_TIE_PREFERENCE;
}

function toRoundingRule(value: string | null | undefined): RoundingRule {
  return ROUNDING_RULES[value?.trim().toUpperCase() ?? ''] ?? DEFAULT_ROUNDING_RULE;
}

export async function fetchLabSettings(): Promise<LabSettings> {
  const preferences = await fetchMessages(MESSAGE_MODELS.systemPreferences, systemPreferenceSchema);
  const tiePreference = preferences.find(isNonNormalTiePreference);

  return {
    roundingRule: toRoundingRule(tiePreference?.valor),
  };
}
